module.exports = __webpack_public_path__ + "img/grass.f226872a.svg";